"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathLight = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M351.3 673.5c213.8 0 322.2-108.3 322.2-322 0-213.8-108.4-322.2-322.2-322.2-213.7 0-322 108.4-322 322.2 0 213.7 108.3 322 322 322zm0-673.5c222 0 351.5 112.1 351.5 351.5S573.3 702.8 351.3 702.8 0 590.9 0 351.5 129.3 0 351.3 0zm14.8 355l103.8 103.9c5.6 5.8 5.5 15.1-.4 20.7-5.7 5.5-14.7 5.5-20.3 0L341 371.5c-2.7-2.8-4.3-6.5-4.3-10.4V214.7c0-8.1 6.6-14.6 14.6-14.6s14.6 6.6 14.6 14.6l.2 140.3z"
  })
});
var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M351.3 658.9c207 0 307.6-100.6 307.6-307.4 0-207-100.6-307.6-307.6-307.6-206.8 0-307.4 100.6-307.4 307.6 0 206.8 100.6 307.4 307.4 307.4zm0-658.9c222 0 351.5 112.1 351.5 351.5S573.3 702.8 351.3 702.8 0 590.9 0 351.5 129.3 0 351.3 0zm22.1 352l101.7 101.8c8.9 8.3 9.4 22.2 1.1 31-8.3 8.9-22.2 9.4-31 1.1l-1.1-1.1-108.2-108.2c-4.1-4.1-6.4-9.7-6.4-15.5V214.7c0-12.1 9.8-22 22-22s22 9.8 22 22l-.1 137.3z"
  })
});
var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M475.1 484.8c-4.3 4.3-9.9 6.4-15.5 6.4-5.7 0-11.2-2.2-15.5-6.4L335.9 376.7c-4.1-4.1-6.4-9.7-6.4-15.6V214.7c0-12.1 9.8-22 22-22s22 9.8 22 22V352l101.8 101.7c8.4 8.6 8.4 22.5-.2 31.1M351.3 0C129.3 0 0 112.1 0 351.5s129.3 351.3 351.3 351.3 351.5-111.9 351.5-351.3S573.3 0 351.3 0"
  })
});

var LlamadaEspera = function LlamadaEspera(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    case _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT:
      path = pathLight;
      break;

    case _gerenciatdUnifiedicons.SVG_ICON_KIND.SOLID:
      path = pathSolid;
      break;

    default:
      path = pathMedium;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '-7 -7 715 715';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "LlamadaEspera-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = LlamadaEspera;
exports["default"] = _default;

//# sourceMappingURL=index.js.map